import { render, staticRenderFns } from "./tiscCard.vue?vue&type=template&id=6a5410dc&scoped=true&"
import script from "./tiscCard.vue?vue&type=script&lang=js&"
export * from "./tiscCard.vue?vue&type=script&lang=js&"
import style0 from "./tiscCard.vue?vue&type=style&index=0&id=6a5410dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5410dc",
  null
  
)

export default component.exports